export default __webpack_public_path__ + "assets/icon-phone-component.5017561d.svg";